import { createSlice } from "@reduxjs/toolkit";

const updateProfileSlice = createSlice({
    name: "UpdateProfile",
    initialState: {
      isProfileUpdatetd: 0,
      
    },
    reducers: {
      profileUpdate(state) {
        
         
        state.isProfileUpdatetd += 1
      },
      
    },
  });
  
  export const { profileUpdate} = updateProfileSlice.actions;
  export default updateProfileSlice.reducer;